import React from "react";

const RequiredMark = () => (
  <span aria-hidden className="required-mark">
    *
  </span>
);
export default RequiredMark;
